import { createStatePropertySelector } from "../../../helpers";
import { selectCommonSlice } from "../../../store/selectors";

const select = createStatePropertySelector(selectCommonSlice);

export const selectRightBarIsOpen = select("isRightBarOpen");
export const selectWidgetIdRightBar = select("widgetIdRightBar");
